import { z } from 'zod';
import { createNumericKeyRecordSchema } from '../KeyRecordSchemas.ts';
import { createPartialStrictObjectSchemaWithAtLeastOneProperty } from '../PartialStrictObjectSchema.ts';
import { validateState } from '../ValidateState.ts';
import { PlayerColor } from '../PlayerState.ts';
import { TileEdgeDirection } from './TileEdgeState.ts';
export var TileEdgePortType = /*#__PURE__*/ function(TileEdgePortType) {
    TileEdgePortType[TileEdgePortType["Port"] = 1] = "Port";
    TileEdgePortType[TileEdgePortType["PortLumber"] = 2] = "PortLumber";
    TileEdgePortType[TileEdgePortType["PortBrick"] = 3] = "PortBrick";
    TileEdgePortType[TileEdgePortType["PortWool"] = 4] = "PortWool";
    TileEdgePortType[TileEdgePortType["PortGrain"] = 5] = "PortGrain";
    TileEdgePortType[TileEdgePortType["PortOre"] = 6] = "PortOre";
    return TileEdgePortType;
}({});
export const portEdgeStateSchema = z.object({
    x: z.number().int().readonly(),
    y: z.number().int().readonly(),
    z: z.enum(TileEdgeDirection).readonly(),
    // TODO: type is missing in some production portEdgeStates — fix upstream and make required again
    type: z.enum(TileEdgePortType).readonly().exactOptional(),
    owner: z.enum(PlayerColor).exclude([
        'None'
    ]).exactOptional()
}).strict();
export function validatePortEdgeState(data) {
    return validateState(portEdgeStateSchema, data);
}
export const portEdgeStatesSchema = createNumericKeyRecordSchema(portEdgeStateSchema);
export function validatePortEdgeStates(data) {
    return validateState(portEdgeStatesSchema, data);
}
export const portEdgeStatePartialSchema = createPartialStrictObjectSchemaWithAtLeastOneProperty(portEdgeStateSchema);
export const portEdgeStatesPartialSchema = createNumericKeyRecordSchema(portEdgeStatePartialSchema, {
    requireAtLeastOneEntry: true
});
